import { ViewModel, ObservableArray, DelegatedObservableArrayChangeListenner } from "binder";
import { PaginationInfo } from "../paginator/paginator-viewModel";
import { ColumnViewModel } from "./column/column-viewModel";
import { BooleanColumnViewModel, DateColumnViewModel, EnumColumnViewModel, NumericColumnViewModel, StringColumnViewModel } from "./column/columnTypes/columnTypes-viewModel";
import { IColumnVisitor } from "./column/columnVisitor";
import { BooleanFilterViewModel } from "./columnFilter/booleanFilter/booleanFilter-viewModel";
import { DateFilterViewModel } from "./columnFilter/dateFilter/dateFilter-viewModel";
import { EnumFilterViewModel } from "./columnFilter/enumFilter/enumFilter-viewModel";
import { NumericFilterViewModel } from "./columnFilter/numericFilter/numericFilter-viewModel";
import { StringFilterViewModel } from "./columnFilter/stringFilter/stringFilter-viewModel";
import { ExTableViewModel } from "./exTable-viewModel";

export class ClientFilteringTable extends ExTableViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filtereditems = ObservableArray.create<ViewModel>();    
        this.items = ObservableArray.create<ViewModel>();    
    }
    private _changeListenner : DelegatedObservableArrayChangeListenner;
    public set items(v: ObservableArray<ViewModel>) { 
        if(this._items!=null){
            this._items.removeChangeListenner(this._changeListenner)
        }
        this._items = v; 
        if(this._items!=null){
            let listenner = new DelegatedObservableArrayChangeListenner(this,x=>this.sourceChanged());
            this._items.addChangeListenner(listenner);
            this.sourceChanged();
        }
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set filtereditems(v: ObservableArray<ViewModel>) { this._filteredItems = v; } public get filtereditems(): ObservableArray<ViewModel> { return this._filteredItems;} private _filteredItems: ObservableArray<ViewModel>;
    
    sourceChanged() {
        this.filterChanged();
    }
    applyFullSearch() {
    }
    clearFullSearch(){
    }
    filterChanged() {
        var checker = new ClientSideFilteringExpressionBuilder();
        this.columns.forEach(x=>x.accept(checker,null));
        this.filtereditems.update(...this.items.filter(x=>checker.checkObject(x)));
        this.sortChanged();
    }
    
    sortChanged() {
        let sorter = new ClientSideSorter();
        let sortingColumns = this.columns.filter(x=>x.columnSort.noSort==false);
        if(sortingColumns.length>0){
            sorter.sort(this.filtereditems,sortingColumns[0]);
        }

        this.informPageChange(this.paginator.currentPage,this.paginator.pageSize);
    }
    informPageChange(pageNo: number, pageSize: number): Promise<PaginationInfo> {
        let maxPageNo =Math.ceil(this.filtereditems.length/pageSize);
        if(pageNo>maxPageNo){
            pageNo = maxPageNo;
        }else if(pageNo<1){
            pageNo=1;
        }
        this.showingitems.update(...this.filtereditems.slice((pageNo-1)*pageSize,(pageNo)*pageSize));
        let paginationInfo = new PaginationInfo(pageNo,maxPageNo);
        let result = Promise.resolve(paginationInfo);
        this.updatePaginationInfo(paginationInfo);
        this.paginator.updatePaginationInfo(pageNo,maxPageNo);
        return result;
    }

}

class ClientSideSorter implements IColumnVisitor{
    sort(filteredItems: ObservableArray<ViewModel>, column: ColumnViewModel) {
        let compareFunction = column.accept(this,null);
        if(column.columnSort.ascending)
            filteredItems.sort(compareFunction);
        else
            filteredItems.sort(function(x,y){
                return -compareFunction(x,y);
            });
    }
    visitBooleanColumn(column: BooleanColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function(x,y){
            if(x[fieldName]==y[fieldName]){
                return 0;
            }else if(x[fieldName]==null){
                return -1;
            }else if(y[fieldName]==null){
                return 1;
            }else if(x[fieldName]==true){
                return 1;
            }else {
                return -1;
            }
        }
    }
    visitDateColumn(column: DateColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function(x,y){
            if(x[fieldName]==y[fieldName]){
                return 0;
            }else if(x[fieldName]==null){
                return -1;
            }else if(y[fieldName]==null){
                return 1;
            }else{
                return (<moment.Moment>x[fieldName]).valueOf()-(<moment.Moment>y[fieldName]).valueOf()
            }
        }
    }
    visitEnumColumn(column: EnumColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function(x,y){
            let xfield:string = null;
            let yfield:string = null;
            if(x[fieldName]!=null)
                xfield = column.enumprovider.translateValue(x[fieldName]);
            if(y[fieldName]!=null)
                yfield = column.enumprovider.translateValue(y[fieldName]);
            if(xfield==yfield){
                return 0;
            }else if(xfield==null){
                return -1;
            }else if(yfield==null){
                return 1;
            }else{
                return (xfield).localeCompare(yfield);
            }
        }
    }
    visitNumericColumn(column: NumericColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function(x,y){
            if(x[fieldName]==y[fieldName]){
                return 0;
            }else if(x[fieldName]==null){
                return -1;
            }else if(y[fieldName]==null){
                return 1;
            }else{
                return x[fieldName]-y[fieldName];
            }
        }
    }
    visitStringColumn(column: StringColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function(x,y){
            if(x[fieldName]==y[fieldName]){
                return 0;
            }else if(x[fieldName]==null){
                return -1;
            }else if(y[fieldName]==null){
                return 1;
            }else{
                return (<string>x[fieldName]).localeCompare(<string>y[fieldName]);
            }
        }
    }

}

class ClientSideFilteringExpressionBuilder implements IColumnVisitor{
    private expressions:any[]=[];
    visitBooleanColumn(column: BooleanColumnViewModel, parameter: any) {
        if(column.filter.isActive){
            let value = (<BooleanFilterViewModel>column.filter).value;
            let fieldName = column.fieldname;
            this.expressions.push(function(param:any):boolean {
                return param[fieldName]==value
            });
        }
    }
    visitDateColumn(column: DateColumnViewModel, parameter: any) {
        if(column.filter.isActive){
            let filter = (<DateFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            let largerThan = filter.largerThan;
            let smallerThan = filter.smallerThan;
            if(filter.applySmaller && filter.applylarger){
                this.expressions.push(function(param:any):boolean {
                    if(param[fieldName]==null)
                        return false;
                    else
                        return (<moment.Moment>param[fieldName]).isSameOrAfter(largerThan) && (<moment.Moment>param[fieldName]).isSameOrBefore(smallerThan);
                });
            }else if(filter.applylarger){
                this.expressions.push(function(param:any):boolean {
                    if(param[fieldName]==null)
                        return false;
                    else
                        return (<moment.Moment>param[fieldName]).isSameOrAfter(largerThan);
                });
            }else if(filter.applySmaller){
                this.expressions.push(function(param:any):boolean {
                    if(param[fieldName]==null)
                        return false;
                    else
                        return (<moment.Moment>param[fieldName]).isSameOrBefore(smallerThan);
                });
            }
        }
    }
    visitEnumColumn(column: EnumColumnViewModel, parameter: any) {
        if(column.filter.isActive){
            let filter = (<EnumFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            let values =new Set(filter.enumValues.filter(x=>x.isSelected).map(x=>x.value));
            this.expressions.push(function(param:any):boolean{
                if(param[fieldName]==null)
                    return true;
                else
                    return values.has(param[fieldName]);
            });
        }
    }
    visitNumericColumn(column: NumericColumnViewModel, parameter: any) {
        if(column.filter.isActive){
            let filter = (<NumericFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            let largerThan = filter.largerThan;
            let smallerThan = filter.smallerThan;
            if(filter.applySmaller && filter.applylarger){
                this.expressions.push(function(param:any):boolean {
                    if(param[fieldName]==null)
                        return false;
                    else
                        return param[fieldName]>=largerThan && param[fieldName]<=smallerThan;
                });
            }else if(filter.applylarger){
                this.expressions.push(function(param:any):boolean {
                    if(param[fieldName]==null)
                        return false;
                    else
                        return param[fieldName]>=largerThan;
                });
            }else if(filter.applySmaller){
                this.expressions.push(function(param:any):boolean {
                    if(param[fieldName]==null)
                        return false;
                    else
                        return param[fieldName]<=smallerThan;
                });
            }
        }
    }
    visitStringColumn(column: StringColumnViewModel, parameter: any) {
        if(column.filter.isActive){
            let filter = (<StringFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            let value = filter.containsValue.toLowerCase();
            if(value!=null && value.trim()!=''){
                this.expressions.push(function(param:any):boolean{
                    if(param[fieldName]==null)
                        return false;
                    else
                        return param[fieldName].toLowerCase().indexOf(value)>-1;
                });
            }
        }
    }
    checkObject(p:any):boolean{
        for(let i=0;i<this.expressions.length;i++){
            if(this.expressions[i](p)==false)
                return false;
        }
        return true;
    }
}